import { ApolloClient, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { InvalidationPolicyCache } from '@nerdwallet/apollo-cache-policies';
import { getAccessTokenSilently } from 'app/security';
import { env } from './../env';

const httpLink = createHttpLink({
    uri: env.REACT_APP_BASE_URL,
});

const authLink = setContext(async (_, { headers }) => {
    const access_token = await getAccessTokenSilently();
    //console.log(access_token);
    //if (!access_token) return null;
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: access_token ? `Bearer ${access_token}` : "",
      }
    }
  });

  const invalidationPolicyCache = new InvalidationPolicyCache({
    typePolicies: {
      Part: {
        keyFields: ["partNumber"]
      }
    },
    invalidationPolicies: {
      types: {
        Comment: {
          timeToLive: 300000,
        }
      }
    }
  });

const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: invalidationPolicyCache
    // cache: new InMemoryCache({
    //   typePolicies: {
    //     Part: {
    //       keyFields: ["partNumber"]
    //     }
    //   },
    //}),
  });


  export { apolloClient }